import { useState } from 'react';
import { Link } from 'react-router-dom';
import { FiMail, FiArrowLeft } from 'react-icons/fi';
import { forgotPassword } from '../../services/api';
import styles from './ForgotPassword.module.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await forgotPassword(email);
      setSent(true);
    } catch (err) {
      setError(err.response?.data?.message || 'Something went wrong. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={styles.page}>
      <div className={styles.card}>
        <div className={styles.iconBox}><FiMail size={24} /></div>
        <h2 className={styles.title}>Forgot Password</h2>

        {sent ? (
          <>
            <p className={styles.desc}>
              If an account with that email exists, we've sent a password reset link. Please check your inbox (and spam folder).
            </p>
            <p className={styles.desc} style={{ marginTop: 0 }}>The link expires in 1 hour.</p>
            <Link to="/login" className={styles.backLink}><FiArrowLeft size={13} /> Back to Sign In</Link>
          </>
        ) : (
          <>
            <p className={styles.desc}>
              Enter the email address associated with your account and we'll send you a link to reset your password.
            </p>
            {error && <div className={styles.errorMsg}>{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Email Address *</label>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => { setEmail(e.target.value); setError(''); }}
                  placeholder="Enter your email address"
                  required
                />
              </div>
              <button type="submit" className="btn btn-primary btn-block" disabled={loading} style={{ marginTop: 8 }}>
                {loading ? 'Sending…' : 'Send Reset Link'}
              </button>
            </form>
            <Link to="/login" className={styles.backLink}><FiArrowLeft size={13} /> Back to Sign In</Link>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
